import { useUpdateReferralCode } from '@src/hooks/useReferrals';
import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
  Input,
  Spinner,
  Text,
  VStack,
} from 'ui_2';

type CreateCustomCodeProps = {
  currentCode?: string;
  friendUsername?: boolean;
  trigger: React.ReactNode;
};

export const CreateCustomCode = ({
  currentCode,
  friendUsername,
  trigger,
}: CreateCustomCodeProps) => {
  const [newReferralCode, setNewReferralCode] = useState<string>('');
  const { updateReferralCode, error, isLoading, isSuccess } =
    useUpdateReferralCode(newReferralCode);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setDialogOpen(false);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (currentCode && !newReferralCode) {
      setNewReferralCode(currentCode);
    }
  }, [currentCode]);

  return (
    <>
      <div onClick={() => setDialogOpen(true)}>{trigger}</div>
      <Dialog open={dialogOpen} onOpenChange={(o) => setDialogOpen(o)}>
        <DialogContent
          className='max-w-[min(90%,400px)]'
          aria-describedby={undefined}
        >
          <DialogTitle>
            <Text font='bold-md'>
              Create a custom {friendUsername ? 'username' : 'referral code'}
            </Text>
          </DialogTitle>
          <DialogClose />
          <VStack className='gap-3'>
            <Input
              label={friendUsername ? 'Username' : 'Referral Code'}
              autoCapitalize='none'
              autoComplete='none'
              autoCorrect='none'
              value={newReferralCode}
              onChange={(e) => setNewReferralCode(e.target.value)}
              disabled={isLoading}
              error={error?.message}
            />
            <Button
              onClick={updateReferralCode}
              disabled={isLoading}
              className='items-center gap-2'
              size='md'
            >
              Save {friendUsername ? 'username' : 'referral code'}
              {isLoading && <Spinner />}
            </Button>
          </VStack>
        </DialogContent>
      </Dialog>
    </>
  );
};
